import { render, staticRenderFns } from "./CatalogInformation.vue?vue&type=template&id=2e23b41a&scoped=true&"
import script from "./CatalogInformation.vue?vue&type=script&lang=ts&"
export * from "./CatalogInformation.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogInformation.vue?vue&type=style&index=0&id=2e23b41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23b41a",
  null
  
)

export default component.exports